export default {
    GET_DOCUMENTS_REQUEST: state => {
        state.documentsLoading = true
    },
    GET_DOCUMENTS_SUCCESS: (state, data) => {
        state.documents = data.results
        state.documentsLoading = false
    },
    GET_DOCUMENTS_FAILURE: state => {
        state.documentsLoading = false
    },

    GET_PRODUCTION_DEPARTMENTS_REQUEST: state => {
        state.productionDepartmentsLoading = true
    },
    GET_PRODUCTION_DEPARTMENTS_SUCCESS: (state, data) => {
        state.productionDepartments = data
        state.productionDepartmentsLoading = false
    },
    GET_PRODUCTION_DEPARTMENTS_FAILURE: state => {
        state.productionDepartmentsLoading = false
    },

    GET_TYPES_REQUEST: state => {
        state.typesLoading = true
    },
    GET_TYPES_SUCCESS: (state, data) => {
        state.types = data
        state.typesLoading = false
    },
    GET_TYPES_FAILURE: state => {
        state.typesLoading = false
    },
    GET_STATUSES_REQUEST: state => {
        state.statusesLoading = true
    },
    GET_STATUSES_SUCCESS: (state, data) => {
        state.statuses = data
        state.statusesLoading = false
    },
    GET_STATUSES_FAILURE: state => {
        state.statusesLoading = false
    },

    SET_CANCEL_TOKEN: (state, { token, fileName }) => {
        state.uploadCancelTokens.push({ token, fileName })
    },

    REMOVE_CANCEL_TOKEN: (state, tokenIndex) => {
        state.uploadCancelTokens.splice(tokenIndex, 1)
    },

    ABORT_FILE_UPLOAD: (state, fileName) => {
        const index = state.uploadCancelTokens.findIndex(item => item.fileName === fileName)

        state.uploadCancelTokens[index].token.cancel('canceled')
    },
}
